import { ComponentProps, useCallback, useMemo } from 'react';
import { IModalDescription, IModalProps, LayoutConfig, ModalIdentifier } from './manager.interface';
import { useManager } from './useManager';

export const useModal = () => {
  const manager = useManager();
  const openModal = useCallback(
    <
      M extends IModalDescription<P>,
      P extends IModalProps<Parameters<P['onSuccess']>[0]> = ComponentProps<Awaited<ReturnType<M['loader']>>>,
    >(
      modal: M,
      props: P,
      parent?: ModalIdentifier,
      layout?: LayoutConfig,
    ) => manager.open(modal, props, parent, layout),
    [manager],
  );
  const closeModal = useCallback((id: ModalIdentifier) => manager.close(id), [manager]);
  return useMemo(() => ({ openModal, closeModal }), [openModal, closeModal]);
};
